// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_PayDespesaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /payroll/pay_despesa endpoint
 *
 * Marks a single despesa as paid with receipt
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Payroll_PayDespesaResponseDados {
period_completed: boolean
}

export type Payroll_PayDespesaResponse = ApiResponse<Payroll_PayDespesaResponseDados>;

registerResponseContract('Payroll_PayDespesaResponse', {
  period_completed: { type: 'boolean', required: true },
})
